import {
  Box,
  Button,
  Divider,
  Drawer,
  MenuItem,
  Typography,
} from '@mui/material';
import { useMutation, useQuery } from 'react-query';
import { useEffect, useMemo, useState } from 'react';
import {
  eventsGet,
  eventEditOptionsGet,
  eventEdit,
  eventDelete,
} from 'api/api';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import AddIcon from '@mui/icons-material/Add';
import { AgGridReact } from 'ag-grid-react';
import { ColDef } from 'ag-grid-community';
import { FastField, Field, Form, Formik } from 'formik';
import * as Yup from 'yup';
import {
  Autocomplete,
  AutocompleteRenderInputParams,
  CheckboxWithLabel,
  Select,
  TextField,
} from 'formik-mui';
import React from 'react';
import moment from 'moment';
import DoneIcon from '@mui/icons-material/Done';
import CloseIcon from '@mui/icons-material/Close';
import { DateTimePicker } from 'formik-mui-lab';
import CircularProgress from '@mui/material/CircularProgress';
import { useNavigate } from 'react-router-dom';
import MuiTextField from '@mui/material/TextField';
import { easepick, RangePlugin, AmpPlugin } from '@easepick/bundle';
import easepickCss from '@easepick/bundle/dist/index.css?resource';
import easepickDarkCss from '../easepick.css?resource';
let picker: easepick.Core | null = null;

export const Events = ({
  selectedOrganization,
}: {
  selectedOrganization: any;
}) => {
  const [dialogOpen, setDialogOpen] = useState(false);
  const navigate = useNavigate();
  const [rightDrawerOpen, setRightDrawerOpen] = useState(false);
  const [alertOpen, setAlertOpen] = useState(false);
  const [alertTitle, setAlertTitle] = useState('');
  const [alertMessage, setAlertMessage] = useState('');
  const [selected, setSelected] = useState<any | null>(null);
  const [dateRange, setDateRange] = useState<{
    start: Date;
    end: Date;
  }>({
    start: moment().startOf('week').toDate(),
    end: moment().endOf('week').toDate(),
  });

  useEffect(() => {
    picker = new easepick.create({
      element: document.getElementById('datepicker')!,
      plugins: [RangePlugin, AmpPlugin],
      css: [easepickCss, easepickDarkCss],
      zIndex: 1,
      //format: 'DD/MM/YYYY',
    });

    picker.setDateRange(dateRange.start, dateRange.end);
    picker.on('select', (e) => {
      const { start, end } = e.detail;

      setDateRange({
        start,
        end,
      });
    });

    return () => {
      picker?.destroy();
    };
  }, []);

  const alert = (title, message) => {
    setAlertTitle(title);
    setAlertMessage(message);
    setAlertOpen(true);
  };

  /*
  const { data: getUserAdminOfOrganizationsResponse } = useQuery(
    'getUserAdminOfOrganizations',
    getUserAdminOfOrganizations,
    {
      enabled: true,
      refetchOnWindowFocus: false,
      suspense: true,
    },
  );

  const userAdminOfOrganizations = getUserAdminOfOrganizationsResponse!.data;

  const [selectedOrganizationId, setSelectedOrganizationId] = useState<number>(
    userAdminOfOrganizations[0]?.id,
  );
  */

  const {
    data: eventOptionsResponse,
    isLoading: eventOptionsIsLoading,
    error: eventOptionsError,
    refetch: refetchEventOptions,
  } = useQuery(
    ['eventOptionsGet', selectedOrganization?.id],
    eventEditOptionsGet(selectedOrganization?.id as number),
    {
      enabled: !!rightDrawerOpen,
      refetchOnWindowFocus: false,
    },
  );
  const eventOptions: any = eventOptionsResponse?.data;

  console.log('selectedOrganization', selectedOrganization);

  const {
    data: response,
    isLoading,
    error,
    refetch,
  } = useQuery(
    ['eventsGet', selectedOrganization?.id, dateRange],
    eventsGet(selectedOrganization?.id as number, dateRange),
    {
      enabled: !!selectedOrganization,
      refetchOnWindowFocus: false,
    },
  );
  const data: any = response?.data;

  const dateFormat = 'YYYY-MM-DD HH:mm';

  const {
    mutateAsync,
    error: mutateError,
    data: mutateData,
    isLoading: mutateIsLoading,
  } = useMutation('eventEdit', eventEdit, {
    onError: (err: any) => {
      alert('Error', err.message);
    },
  });

  const { columnDefs, rowData } = useMemo(() => {
    if (!data?.length) {
      return { rowData: [] };
    }
    const columnDefs: ColDef[] = [
      {
        field: 'name',
        headerName: 'Name',
        sortable: true,
        // eslint-disable-next-line sonarjs/no-duplicate-string
        flex: 3,
        minWidth: 210,
        filter: true,
      },
      {
        field: 'public',
        headerName: 'Public',
        headerClass: 'ag-narrow',
        cellClass: 'ag-narrow',
        sortable: true,
        // eslint-disable-next-line sonarjs/no-duplicate-string
        flex: 0.5,
        minWidth: 80,
        filter: true,
        cellRenderer: ({ data }) => {
          return data.public ? <DoneIcon /> : <CloseIcon />;
        },
      },

      {
        field: 'preShowStartTime',
        headerName: 'Preshow start time',
        headerClass: 'ag-narrow',
        cellClass: 'ag-narrow',
        sortable: true,
        flex: 1,
        minWidth: 140,
        valueFormatter: ({ data }) => {
          return moment(data.preShowStartTime).format(dateFormat);
        },
      },
      {
        field: 'featureStartTime',
        headerName: 'Feature start time',
        headerClass: 'ag-narrow',
        cellClass: 'ag-narrow',
        sortable: true,
        flex: 1,
        minWidth: 140,
        valueFormatter: ({ data }) => {
          return moment(data.featureStartTime).format(dateFormat);
        },
      },
      {
        field: 'featureEndTime',
        headerName: 'Feature end time',
        headerClass: 'ag-narrow',
        cellClass: 'ag-narrow',
        sortable: true,
        flex: 1,
        minWidth: 140,
        valueFormatter: ({ data }) => {
          return moment(data.featureEndTime).format(dateFormat);
        },
      },
    ];

    return { columnDefs, rowData: data };
  }, [data]);

  console.log('selected', selected);

  return (
    <>
      <React.Fragment key="right">
        <Drawer
          anchor="right"
          open={rightDrawerOpen}
          onClose={() => {
            refetch();
            setRightDrawerOpen(false);
          }}
        >
          <Box sx={{ width: { xs: '100vw', sm: '600px' } }}>
            <Typography
              variant="h1"
              sx={{ fontSize: '1.3em', fontWeight: 500, m: '16px 24px' }}
            >
              {!!selected ? 'Edit event' : 'Add event'}
            </Typography>
            <Divider />
            <Box sx={{ padding: '24px' }}>
              <Box sx={{ mb: '20px' }}>
                <Typography sx={{ fontWeight: 500, display: 'inline' }}>
                  Organization:{' '}
                </Typography>
                {selectedOrganization?.name}
              </Box>
              {/*
              {!!selected && (
                <Box sx={{ mb: '16px' }}>
                  <Typography sx={{ fontWeight: 500, display: 'inline' }}>
                    User:{' '}
                  </Typography>
                  {selected?.name}
                </Box>
              )}
              */}
              {(!!eventOptionsIsLoading || !!isLoading) && (
                <Box sx={{ textAlign: 'center', mt: 6 }}>
                  <CircularProgress />
                </Box>
              )}
              {!!eventOptions && (
                <>
                  {!selected &&
                    !eventOptions?.eventTypes &&
                    'You need to add an event type.'}
                  {!selected &&
                    !eventOptions?.venueParts &&
                    'You need to add a venue and its part(s).'}
                  {!selected &&
                    !eventOptions?.ticketTypeSets &&
                    'You need to add a ticket type set and make sure it has at least one ticket in it.'}

                  <Formik
                    validateOnMount
                    initialValues={{
                      name: selected?.name || '',
                      venuePartId: selected?.venuePartId || '',
                      eventTypeId: selected?.eventTypeId || '',
                      ticketTypeSetId: selected?.ticketTypeSetId || '',
                      public: selected?.public || true,
                      preShowStartTime:
                        selected?.preShowStartTime ||
                        moment()
                          .add(1, 'w')
                          .isoWeekday('Saturday')
                          .startOf('day')
                          .add(20, 'h'),
                      featureStartTime:
                        selected?.featureStartTime ||
                        moment()
                          .add(1, 'w')
                          .isoWeekday('Saturday')
                          .startOf('day')
                          .add(20, 'h'),
                      featureEndTime:
                        selected?.featureStartTime ||
                        moment()
                          .add(1, 'w')
                          .isoWeekday('Saturday')
                          .startOf('day')
                          .add(22, 'h'),
                      salesCutOffTime:
                        selected?.salesCutOffTime ||
                        moment()
                          .add(1, 'w')
                          .isoWeekday('Saturday')
                          .startOf('day')
                          .add(22, 'h'),
                    }}
                    validationSchema={Yup.object().shape({
                      name: Yup.string().required('Required'),
                    })}
                    onSubmit={async (values: any, { setSubmitting }) => {
                      values.organizationId = selectedOrganization.id;
                      try {
                        await mutateAsync({ values });
                      } catch (error: any) {
                        alert(error.error, error.message);
                      }
                      refetch();
                      setSubmitting(false);
                      setRightDrawerOpen(false);
                    }}
                  >
                    {({
                      submitForm,
                      isSubmitting,
                      values,
                      isValid,
                      handleChange,
                      getFieldProps,
                      errors,
                      touched,
                      handleBlur,
                      setFieldValue,
                    }) => (
                      <Form style={{ width: '100%' }}>
                        <Box
                          sx={{
                            width: '100%',
                            marginInline: 'auto',
                            display: 'flex',
                            flexDirection: 'column',
                            gap: 2,
                            position: 'relative',
                          }}
                        >
                          <Box className="small-formik-select-fix">
                            <Field
                              component={Autocomplete}
                              options={
                                eventOptions?.eventTypes.map((t) => t.id) || []
                              }
                              getOptionLabel={(selectedEventTypeId: any) =>
                                eventOptions?.eventTypes.find(
                                  (t) => t.id === selectedEventTypeId,
                                )?.name || ''
                              }
                              onChange={(_e, newValue) => {
                                setFieldValue('eventTypeId', newValue);
                                const selectedEvent =
                                  eventOptions?.eventTypes.find(
                                    (t) => t.id === newValue,
                                  );

                                if (selectedEvent) {
                                  if (!values.name) {
                                    setFieldValue('name', selectedEvent.name);
                                  }

                                  const currentStartTime =
                                    values.featureStartTime;

                                  if (currentStartTime) {
                                    setFieldValue(
                                      'featureEndTime',
                                      moment(currentStartTime).add(
                                        selectedEvent.duration,
                                        'minutes',
                                      ),
                                    );
                                    setFieldValue(
                                      'salesCutOffTime',
                                      moment(currentStartTime).add(
                                        selectedEvent.duration,
                                        'minutes',
                                      ),
                                    );
                                  }
                                }
                              }}
                              label="Event type"
                              id="eventTypeId"
                              name="eventTypeId"
                              size="small"
                              required
                              renderInput={(
                                params: AutocompleteRenderInputParams,
                              ) => (
                                <MuiTextField
                                  {...params}
                                  name="eventTypeId"
                                  error={
                                    touched['eventTypeId'] &&
                                    !!errors['eventTypeId']
                                  }
                                  helperText={errors['eventTypeId'] as string}
                                  label="Event type"
                                  variant="outlined"
                                />
                              )}
                            />
                          </Box>
                          <FastField
                            component={TextField}
                            label="Name"
                            name="name"
                            size="small"
                          />
                          <Box className="small-formik-select-fix">
                            <FastField
                              component={Select}
                              label="Venue part"
                              id="venuePartId"
                              name="venuePartId"
                              size="small"
                              required
                            >
                              {!!eventOptions?.venueParts &&
                                eventOptions?.venueParts.map((p) => (
                                  <MenuItem key={p.id} value={p.id}>
                                    {p.venue.name + ' - ' + p.name}
                                  </MenuItem>
                                ))}
                            </FastField>
                          </Box>
                          <Box className="small-formik-select-fix">
                            <FastField
                              component={Select}
                              label="Ticket type set"
                              id="ticketTypeSetId"
                              name="ticketTypeSetId"
                              size="small"
                              required
                            >
                              {!!eventOptions?.ticketTypeSets &&
                                eventOptions?.ticketTypeSets.map((s) => (
                                  <MenuItem key={s.id} value={s.id}>
                                    {s.name}
                                  </MenuItem>
                                ))}
                            </FastField>
                          </Box>
                          <Box className="small-date-picker">
                            <FastField
                              component={DateTimePicker}
                              label="Preshow start time"
                              name="preShowStartTime"
                              size="small"
                            />
                          </Box>
                          <Box className="small-date-picker">
                            <Field
                              component={DateTimePicker}
                              label="Feature start time"
                              name="featureStartTime"
                              size="small"
                              onChange={(newValue) => {
                                setFieldValue('featureStartTime', newValue);
                                const selectedEvent =
                                  eventOptions?.eventTypes.find(
                                    (t) => t.id === values.eventTypeId,
                                  );

                                console.log('newValue', newValue);

                                if (selectedEvent) {
                                  setFieldValue(
                                    'featureEndTime',
                                    moment(newValue).add(
                                      selectedEvent.duration,
                                      'minutes',
                                    ),
                                  );
                                  setFieldValue(
                                    'salesCutOffTime',
                                    moment(newValue).add(
                                      selectedEvent.duration,
                                      'minutes',
                                    ),
                                  );
                                }
                              }}
                            />
                          </Box>
                          <Box className="small-date-picker">
                            <FastField
                              component={DateTimePicker}
                              label="Feature end time"
                              name="featureEndTime"
                              size="small"
                            />
                          </Box>
                          <Box className="small-date-picker">
                            <FastField
                              component={DateTimePicker}
                              label="Sales cutoff time"
                              name="salesCutOffTime"
                              size="small"
                            />
                          </Box>
                          <FastField
                            component={CheckboxWithLabel}
                            type="checkbox"
                            name="public"
                            Label={{ label: 'Public' }}
                            size="small"
                          />
                          <Box
                            sx={{
                              textAlign: 'right',
                              margin: '16px 0',
                              display: 'flex',
                              flexDirection: 'row',
                            }}
                          >
                            <Button
                              color="primary"
                              disabled={isSubmitting}
                              onClick={() => setRightDrawerOpen(false)}
                              sx={{ padding: '6px 8px' }}
                            >
                              Cancel
                            </Button>

                            <Box sx={{ flex: '1 1 auto' }} />
                            {!!selected && (
                              <Button
                                color="primary"
                                disabled={isSubmitting}
                                onClick={() => setDialogOpen(true)}
                                sx={{ padding: '6px 8px' }}
                              >
                                Delete
                              </Button>
                            )}
                            <Box sx={{ flex: '1 1 auto' }} />
                            <Button
                              color="primary"
                              variant="contained"
                              disabled={isSubmitting || !isValid}
                              sx={{ padding: '6px 24px' }}
                              onClick={submitForm}
                            >
                              {!!selected ? 'Save' : 'Add'}
                            </Button>
                          </Box>
                        </Box>
                      </Form>
                    )}
                  </Formik>
                </>
              )}
            </Box>
          </Box>
        </Drawer>
      </React.Fragment>
      <Dialog
        open={alertOpen}
        onClose={() => setAlertOpen(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{`${alertTitle}`}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {`${alertMessage}`}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setAlertOpen(false)}>OK</Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={dialogOpen}
        onClose={() => setDialogOpen(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {'Deletion confirmation'}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {`Are you sure you want to delete this? The event will not be deleted if it has sold tickets.`}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setDialogOpen(false)}>Cancel</Button>
          <Button
            onClick={async () => {
              try {
                const response = await eventDelete(selected.id)();
                setDialogOpen(false);
                if (response) {
                  refetch();
                  setDialogOpen(false);
                  setRightDrawerOpen(false);
                }
              } catch (error: any) {
                refetch();
                setDialogOpen(false);
                setRightDrawerOpen(false);
                alert(error.error, error.message);
              }
            }}
          >
            Delete
          </Button>
        </DialogActions>
      </Dialog>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          flexGrow: '1',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            flexShrink: 0,
            flexGrow: 0,
            alignItems: 'center',
            gap: '5px 6px',
            minHeight: '56px',
            maxWidth: '100vw',
            flexWrap: 'wrap',
            padding: '8px 0 8px',
          }}
        >
          <Typography
            variant="h4"
            component="h2"
            sx={{
              fontSize: '1.25rem',
            }}
          >
            Events
          </Typography>
          <MuiTextField
            size="small"
            id="datepicker"
            sx={{
              ml: '6px',
              minWidth: '200px',
            }}
          />
          <Button
            color="primary"
            onClick={() => {
              setSelected(null);
              refetchEventOptions();
              setRightDrawerOpen(true);
            }}
          >
            <AddIcon sx={{ ml: -0.5, mr: 0 }} />
            Add new
          </Button>
          <Button
            color="primary"
            onClick={() => {
              setDateRange({
                start: moment().subtract(1, 'months').startOf('month').toDate(),
                end: moment().subtract(1, 'months').endOf('month').toDate(),
              });
              picker?.setDateRange(
                moment().subtract(1, 'months').startOf('month').toDate(),
                moment().subtract(1, 'months').endOf('month').toDate(),
              );
            }}
          >
            Last month
          </Button>
          <Button
            color="primary"
            onClick={() => {
              setDateRange({
                start: moment().subtract(1, 'd').toDate(),
                end: moment().subtract(1, 'd').toDate(),
              });
              picker?.setDateRange(
                moment().subtract(1, 'd').toDate(),
                moment().subtract(1, 'd').toDate(),
              );
            }}
          >
            Yesterday
          </Button>
        </Box>

        <Box
          className="ag-theme-material"
          sx={{
            background: '#000',
            borderRadius: 0,
            margin: '0 -16px -16px',
            display: 'flex',
            overflow: 'hidden',
            flexGrow: 1,
            height: '100%',
            boxShadow:
              'rgb(0 0 0 / 20%) 0px 2px 1px -1px, rgb(0 0 0 / 14%) 0px 1px 1px 0px, rgb(0 0 0 / 12%) 0px 1px 3px 0px',
          }}
        >
          <AgGridReact
            className="ag-pointer-row"
            rowData={rowData}
            pagination={true}
            floatingFiltersHeight={50}
            paginationAutoPageSize={true}
            columnDefs={columnDefs}
            onRowClicked={({ data }) => {
              navigate(`/admin/event/${data.id}`);
              /*
              setSelected(data);
              setRightDrawerOpen(true);
              */
            }}
          ></AgGridReact>
        </Box>
      </Box>
    </>
  );
};
